import {connect} from 'react-redux';
import PageHeader from '../../components/PageHeader';
import {loadArticles, updateSearch} from '../../actions';
import {withRouter} from 'react-router-dom';

function mapStateToProps(state) {
  return {
    experiments: state.experiments.active,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadArticles: tag => dispatch(loadArticles(tag)),
    updateSearch: searchTerms => dispatch(updateSearch(searchTerms))
  };
}
const connected: any = connect(mapStateToProps, mapDispatchToProps)(PageHeader);
export default <any>withRouter(connected);
